"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csvBuild = void 0;
const valueSetMapToValueArrayMap = (valueSets) => {
    return Object.keys(valueSets).reduce((acc, key) => {
        acc[key] = Array.from(valueSets[key]);
        return acc;
    }, {});
};
const getValueByType = (value, type) => {
    switch (type) {
        case "boolean":
            return value ? "true" : "false";
        case "number":
            return !isNaN(value) ? value.toString() : "";
        case "string":
        default:
            return value ? `"${value}"` : "";
    }
};
const csvBuild = async ({ header, columnsTypes, valueSets, write, logger }) => {
    const startTime = Date.now();
    const headerLine = header.map(col => `"${col}"`).join(",");
    const valuesArrays = valueSetMapToValueArrayMap(valueSets);
    const rows = Math.max(...Object.values(valueSets).map(x => x.size));
    write(`${headerLine}\n`);
    for (let row = 0; row < rows; row++) {
        logger === null || logger === void 0 ? void 0 : logger(`Row ${row + 1}/${rows}`);
        const rowLine = header.map(col => getValueByType(valuesArrays[col][row], columnsTypes[col])).join(",");
        write(`${rowLine}\n`);
    }
    logger === null || logger === void 0 ? void 0 : logger(`Duration (ms): ${Date.now() - startTime}`);
};
exports.csvBuild = csvBuild;
//# sourceMappingURL=csvBuilder.js.map